import { c as _c } from "react/compiler-runtime";
import { FormInput, PrimaryButton } from '@systemeio/ui';
import { createDomain } from 'modules/profile/custom-domains-settings/api/custom-domain-api';
import { CustomDomainsCreateInterface, CustomDomainsSettingsInterface } from 'modules/profile/custom-domains-settings/types/custom-domains-settings-interface';
import React, { useState } from 'react';
import CreateModal from 'shared/components/create-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { fetchWithErrors } from 'shared/utils/fetch-with-errors';
import { getDomainInfoLink } from 'shared/utils/get-domain-info-link';
import { AddIcon } from '@systemeio/ui/icons';
interface CreateDomainErrorsInterface {
  domainName: string;
}
const defaultErrors: CreateDomainErrorsInterface = {
  domainName: ''
};
const defaultValues: CustomDomainsCreateInterface = {
  domainName: ''
};
interface CreateDomainModalInterface {
  createDomainWithUpdate: (domain: CustomDomainsSettingsInterface) => Promise<void>;
}
const CreateDomainModal = t0 => {
  const $ = _c(31);
  const {
    createDomainWithUpdate
  } = t0;
  const {
    user
  } = useUser();
  const {
    t
  } = useLocoTranslation();
  const [opened, setOpened] = useState(false);
  const [errors, setErrors] = useState(defaultErrors);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setErrors(defaultErrors);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const afterLeave = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setOpened(false);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const onClose = t2;
  let t3;
  if ($[2] !== createDomainWithUpdate) {
    t3 = async data => {
      await fetchWithErrors(async () => {
        const response = await createDomain(data);
        await createDomainWithUpdate(response.data);
      }, setErrors);
    };
    $[2] = createDomainWithUpdate;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const onCreate = t3;
  const t4 = !user;
  let t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setOpened(true);
    t6 = <AddIcon />;
    $[4] = t5;
    $[5] = t6;
  } else {
    t5 = $[4];
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t) {
    t7 = t("dashboard.settings.custom_domains.add_domain");
    $[6] = t;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t7) {
    t8 = <span className="hidden sm:flex">{t7}</span>;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t4 || $[11] !== t8) {
    t9 = <PrimaryButton disabled={t4} className="flex items-center justify-between" onClick={t5}>{t6}{t8}</PrimaryButton>;
    $[10] = t4;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t) {
    t10 = t("dashboard.settings.custom_domains.add_domain");
    $[13] = t;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t) {
    t11 = t("global.domain");
    $[15] = t;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== errors || $[18] !== t || $[19] !== user?.dashboardLocale) {
    t12 = [{
      field: "domainName",
      onRender: (value, onChange) => <FormInput key="domainName-create" label={t("dashboard.settings.custom_domains.domain_name")} value={value} onChange={e => onChange(e.target.value)} error={errors.domainName} description={<a className="primary-link" href={getDomainInfoLink(user?.dashboardLocale)} target="_blank" rel="noreferrer">{t("dashboard.settings.custom_domains.add_domain_description")}</a>} />
    }];
    $[17] = errors;
    $[18] = t;
    $[19] = user?.dashboardLocale;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = ["domainName"];
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== onCreate || $[23] !== opened || $[24] !== t10 || $[25] !== t11 || $[26] !== t12) {
    t14 = <CreateModal fullCaption={t10} caption={t11} opened={opened} onClose={onClose} afterLeave={afterLeave} defaultValues={defaultValues} creatable={t12} onCreate={onCreate} requiredFields={t13} />;
    $[22] = onCreate;
    $[23] = opened;
    $[24] = t10;
    $[25] = t11;
    $[26] = t12;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t14 || $[29] !== t9) {
    t15 = <>{t9}{t14}</>;
    $[28] = t14;
    $[29] = t9;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  return t15;
};
export default CreateDomainModal;